import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { CadastroService } from '../../../../services/cadastro.service';
import { ProdutoDTO } from '../../../../models/cadastro.model';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ErrorModel } from '../../../../models/error.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-produtos',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './produtos.component.html',
  styleUrls: ['./produtos.component.css']
})
export class ProdutosComponent implements OnInit {
  produtos: ProdutoDTO[] = [];
  filteredProdutos: ProdutoDTO[] = [];
  paginatedProdutos: ProdutoDTO[] = [];
  
  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 1;
  maxPagesToShow = 5;
  startPage!: number;
  endPage!: number;
  pages: number[] = [];

  searchTerm = '';

  constructor(
    private cadastroService: CadastroService, 
    private router: Router,
    private toastr: ToastrService
  ) { }
  
  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.loadProdutos();
  } 

  loadProdutos(): void {
    this.cadastroService.getProdutosSimples().subscribe(data => {
      this.produtos = data;
      this.filteredProdutos = data;
      this.totalPages = Math.max(1, Math.ceil(this.filteredProdutos.length / this.itemsPerPage));
      this.setPage(1);
      this.cdr.detectChanges();
    });
  }

  search(): void {
    this.filteredProdutos = this.produtos.filter(produto =>
      produto.nomeProduto.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
    this.totalPages = Math.max(1, Math.ceil(this.filteredProdutos.length / this.itemsPerPage));
    this.setPage(1);
  }

  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.filteredProdutos.length);
    this.paginatedProdutos = this.filteredProdutos.slice(startIndex, endIndex);
    this.updatePageNumbers();
  }

  updatePageNumbers(): void {
    const halfPages = Math.floor(this.maxPagesToShow / 2);
    this.startPage = Math.max(1, this.currentPage - halfPages);
    this.endPage = Math.min(this.totalPages, this.startPage + this.maxPagesToShow - 1);

    if (this.endPage - this.startPage + 1 < this.maxPagesToShow) {
      this.startPage = Math.max(1, this.endPage - this.maxPagesToShow + 1);
    }

    this.pages = Array.from(
      { length: (this.endPage - this.startPage) + 1 },
      (_, i) => this.startPage + i
    );
  }

  novoProduto(): void {
    this.router.navigate(['/home', 'produto-cadastro-manutencao']);
  }

  editarProduto(id: number): void {
    this.router.navigate(['/home', 'produto-cadastro-manutencao', id]);
  }

  definirPreco(id: number): void {
    this.router.navigate(['/home', 'produto-historico-preco', id]);
  }

}
